var _path, _circle, _circle2, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailSent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 173,
    viewBox: "0 0 174 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.643 63H58.3571C57.0689 63 55.8335 63.5057 54.9226 64.4059C54.0117 65.3061 53.5 66.527 53.5 67.8V106.2C53.5 107.473 54.0117 108.694 54.9226 109.594C55.8335 110.494 57.0689 111 58.3571 111H116.643C117.931 111 119.166 110.494 120.077 109.594C120.988 108.694 121.5 107.473 121.5 106.2V67.8C121.5 66.527 120.988 65.3061 120.077 64.4059C119.166 63.5057 117.931 63 116.643 63ZM111.3 67.8L87.5 84.072L63.7 67.8H111.3ZM58.3571 106.2V69.984L86.1157 88.968C86.5222 89.2467 87.0052 89.3961 87.5 89.3961C87.9948 89.3961 88.4778 89.2467 88.8843 88.968L116.643 69.984V106.2H58.3571Z",
    fill: "#4A4A4A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 86.5,
    r: 83.5,
    stroke: "#CCCCCC",
    strokeWidth: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.5,
    cy: 69,
    r: 14,
    fill: "#2D91E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.5 55C112.731 55 110.024 55.8211 107.722 57.3594C105.42 58.8978 103.625 61.0843 102.566 63.6424C101.506 66.2006 101.229 69.0155 101.769 71.7313C102.309 74.447 103.643 76.9416 105.601 78.8995C107.558 80.8574 110.053 82.1908 112.769 82.731C115.484 83.2712 118.299 82.9939 120.858 81.9343C123.416 80.8747 125.602 79.0803 127.141 76.778C128.679 74.4757 129.5 71.7689 129.5 69C129.5 65.287 128.025 61.726 125.399 59.1005C122.774 56.475 119.213 55 115.5 55ZM115.5 81C113.127 81 110.807 80.2962 108.833 78.9776C106.86 77.6591 105.322 75.7849 104.413 73.5922C103.505 71.3995 103.268 68.9867 103.731 66.6589C104.194 64.3311 105.336 62.1929 107.015 60.5147C108.693 58.8365 110.831 57.6936 113.159 57.2306C115.487 56.7676 117.899 57.0052 120.092 57.9134C122.285 58.8217 124.159 60.3598 125.478 62.3332C126.796 64.3065 127.5 66.6266 127.5 69C127.5 72.1826 126.236 75.2348 123.985 77.4853C121.735 79.7357 118.683 81 115.5 81Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.5 74.5L108.5 69.54L110.09 67.97L113.5 71.35L120.91 64L122.5 65.58L113.5 74.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSent);
export default __webpack_public_path__ + "static/media/mail-sent.88af01f86ac8219508c08f46c297a0ad.svg";
export { ForwardRef as ReactComponent };